import React from "react";
import { Modal, Button } from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {getVideoByKey} from "../../../../utils/videoUtils";


export const VideoModal = ({ show, videoUrl, onClose }: any) => {
    const {t} = useTranslation();
    return (
        <Modal show={show} onHide={onClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('Alerts.video')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    videoUrl && (
                        <video width="100%" height="auto" controls>
                            <source src={getVideoByKey(videoUrl)} type="video/mp4" />
                            {t('Alerts.video_not_supported')}
                        </video>
                    )
                }

            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={onClose}>{t('Alerts.close')}</Button>
            </Modal.Footer>
        </Modal>
    );
};